import { render, staticRenderFns } from "./pageloader.html?vue&type=template&id=0a357b40&scoped=true&"
import script from "./pageloader.js?vue&type=script&lang=js&"
export * from "./pageloader.js?vue&type=script&lang=js&"
import style0 from "./pageloader.scss?vue&type=style&index=0&id=0a357b40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a357b40",
  null
  
)

export default component.exports